export default __webpack_public_path__ + "49b6b7edaad939b7ef72f01a156aa5f5.svg";